import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const ImporteIgvFormGroup = ({ iError, iTouched, fIsSubmitting, values, setValues }) => {
  const onChange = React.useCallback(
    e => {
      const nuevoValor = parseFloat(e.target.value || '0')

      const importeTotal = parseFloat(
        (
          values.importeGravado +
          values.importeNoGravado +
          values.importeOtros +
          nuevoValor
        ).toFixed(2)
      )

      values.importeIgv = nuevoValor
      values.importeTotal = importeTotal
      setValues(values)
    },
    [values, setValues]
  )

  return (
    <Form.Group>
      <Form.Label text='IGV' htmlFor='input-importeIgv' md={12} />
      <Col md={12}>
        <Field name='importeIgv'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-importeIgv'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteIgvFormGroup)
